import {
  takeEvery, all, call, put, select,
} from 'redux-saga/effects';

import {
  apiGetXeroBankAccounts,
  apiGetXeroBankAccountCodes,
  apiGetXeroBankAccountMappings,
  apiPutXeroBankAccountMappings,
} from './api';

import {
  getXeroBankAccountsActionTypes,
  getXeroBankAccountsActions,
  getXeroBankAccountCodesActionTypes,
  getXeroBankAccountCodesActions,
  getXeroBankAccountMappingsActionTypes,
  getXeroBankAccountMappingsActions,
  putXeroBankAccountMappingsActionTypes,
  putXeroBankAccountMappingsActions,
  setActiveXeroBankAccountsActionType,
  setActiveXeroBankAccountsAction,
  resetXeroBankAccountMappingsActionType,
} from './actions';

function* getXeroBankAccounts() {
  try {
    yield put(getXeroBankAccountsActions.request());
    const { companyId } = yield select((state) => state.appService);
    const response = yield call(() => apiGetXeroBankAccounts(companyId));
    const responseJson = yield response.json();
    const accounts = responseJson.data.items;
    yield put(getXeroBankAccountsActions.success(accounts));
    yield put(setActiveXeroBankAccountsAction(accounts[0]));
  } catch (error) {
    console.log(error);
    yield put(getXeroBankAccountsActions.error(error));
  }
}

function* watchGetXeroBankAccounts() {
  yield takeEvery(getXeroBankAccountsActionTypes.common, getXeroBankAccounts);
}

function* getXeroBankAccountCodes({ accountId }) {
  try {
    yield put(getXeroBankAccountCodesActions.request());
    const { companyId } = yield select((state) => state.appService);
    const response = yield call(() => apiGetXeroBankAccountCodes(
      companyId,
      accountId,
    ));
    const responseJson = yield response.json();
    yield put(getXeroBankAccountCodesActions.success(
      responseJson.data.items,
    ));
  } catch (error) {
    console.log(error);
    yield put(getXeroBankAccountCodesActions.error(error));
  }
}

function* watchGetXeroBankAccountCodes() {
  yield takeEvery(getXeroBankAccountCodesActionTypes.common, getXeroBankAccountCodes);
}

function* getXeroBankAccountMappings({ accountId }) {
  try {
    yield put(getXeroBankAccountMappingsActions.request());
    const { companyId } = yield select((state) => state.appService);
    const response = yield call(() => apiGetXeroBankAccountMappings(
      companyId,
      accountId,
    ));
    const responseJson = yield response.json();
    yield put(getXeroBankAccountMappingsActions.success(
      responseJson.data.items,
    ));
  } catch (error) {
    console.log(error);
    yield put(getXeroBankAccountMappingsActions.error(error));
  }
}

function* watchGetXeroBankAccountMappings() {
  yield takeEvery(getXeroBankAccountMappingsActionTypes.common, getXeroBankAccountMappings);
}

function* putXeroBankAccountMappings() {
  try {
    yield put(putXeroBankAccountMappingsActions.request());
    const { companyId } = yield select((state) => state.appService);
    const { xeroMappings, selectedAccount } = yield select((state) => state.xeroService);

    const response = yield call(() => apiPutXeroBankAccountMappings(
      companyId,
      selectedAccount.id,
      xeroMappings,
    ));
    const responseJson = yield response.json();
    yield put(putXeroBankAccountMappingsActions.success(
      responseJson.data.items,
    ));
  } catch (error) {
    console.log(error);
    yield put(putXeroBankAccountMappingsActions.error(error));
  }
}

function* watchPutXeroBankAccountMappings() {
  yield takeEvery(putXeroBankAccountMappingsActionTypes.common, putXeroBankAccountMappings);
}

function* onSetActiveXeroBankAccountsAction({ account }) {
  yield put(getXeroBankAccountCodesActions.common(account.id));
  yield put(getXeroBankAccountMappingsActions.common(account.id));
}

function* watchSetActiveXeroBankAccountsAction() {
  yield takeEvery(setActiveXeroBankAccountsActionType, onSetActiveXeroBankAccountsAction);
}

function* onResetXeroBankAccountMappings() {
  const { selectedAccount } = yield select((state) => state.xeroService);
  yield put(getXeroBankAccountMappingsActions.common(selectedAccount.id));
}

function* wetchResetXeroBankAccountMappingsAction() {
  yield takeEvery(resetXeroBankAccountMappingsActionType, onResetXeroBankAccountMappings);
}

export default function* root() {
  yield all([
    watchGetXeroBankAccounts(),
    watchGetXeroBankAccountCodes(),
    watchGetXeroBankAccountMappings(),
    watchPutXeroBankAccountMappings(),
    watchSetActiveXeroBankAccountsAction(),
    wetchResetXeroBankAccountMappingsAction(),
  ]);
}
